/**
 * Page type
 */
export enum PageType {
  Standard = 'standard',
  FullscreenImage = 'fullscreen_image',
  ImageWide = 'image_wide',
}
